var render, staticRenderFns
import script from "./MpsFormStyle.vue?vue&type=script&lang=js"
export * from "./MpsFormStyle.vue?vue&type=script&lang=js"
import style0 from "./MpsFormStyle.vue?vue&type=style&index=0&id=9fa4f6a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports